import api from './api'

const inventoryService = {
  // Items
  getItems: (params) => api.get('/inventory/items', { params }),
  getItemById: (id) => api.get(`/inventory/items/${id}`),
  createItem: (itemData) => api.post('/inventory/items', itemData),
  updateItem: (id, itemData) => api.put(`/inventory/items/${id}`, itemData),
  deleteItem: (id) => api.delete(`/inventory/items/${id}`),
  
  // Locations
  getLocations: () => api.get('/inventory/locations'),
  createLocation: (locationData) => api.post('/inventory/locations', locationData),
  
  // Movements
  getMovements: (params) => api.get('/inventory/movements', { params }),
  createMovement: (movementData) => api.post('/inventory/movements', movementData),
  
  // Batches
  getBatches: (params) => api.get('/inventory/batches', { params }),
  createBatch: (batchData) => api.post('/inventory/batches', batchData),
  updateBatch: (id, batchData) => api.put(`/inventory/batches/${id}`, batchData),
  
  // Serial Numbers
  getSerials: (params) => api.get('/inventory/serials', { params }),
  createSerial: (serialData) => api.post('/inventory/serials', serialData),
  updateSerial: (id, serialData) => api.put(`/inventory/serials/${id}`, serialData),
  
  // Stock Adjustments
  adjustStock: (itemId, adjustmentData) => api.post(`/inventory/items/${itemId}/adjust`, adjustmentData),
  
  // Reports
  getLowStockReport: () => api.get('/inventory/reports/low-stock'),
  getStockValuationReport: () => api.get('/inventory/reports/valuation'),
  getMovementReport: (params) => api.get('/inventory/reports/movements', { params }),
  getDashboardStats: (params) => api.get('/inventory/dashboard/stats', { params }),
  getReports: (params) => api.get('/inventory/reports', { params }),
  
  // Location management
  updateLocation: (id, locationData) => api.put(`/inventory/locations/${id}`, locationData),
  deleteLocation: (id) => api.delete(`/inventory/locations/${id}`),

  // POS
  getPOSTransactions: (params) => api.get('/pos/transactions', { params }),
  getPOSTransaction: (id) => api.get(`/pos/transactions/${id}`),
  createPOSSale: (saleData) => api.post('/pos/transactions', saleData),
  updatePOSTransaction: (id, data) => api.put(`/pos/transactions/${id}`, data),
  voidPOSTransaction: (id) => api.delete(`/pos/transactions/${id}`),
  getPOSDashboard: () => api.get('/pos/dashboard'),
}

export { inventoryService };
export default inventoryService;